import { render, staticRenderFns } from "./yj_list_wy.vue?vue&type=template&id=0e586fb6&scoped=true&"
import script from "./yj_list_wy.vue?vue&type=script&lang=js&"
export * from "./yj_list_wy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e586fb6",
  null
  
)

export default component.exports